<template lang="pug">
div
  .md-form-group
    label Search
    input(
      type="text"
      name="search"
      v-model="search"
      class="form-control"
      @input="onFiltersChange"
    )
  .md-form-group
    label {{ trans('pricebook.category') }}
    select(
      class="form-control c-select" 
      v-model="category"
      @change="onFiltersChange"
    )
      option(:value="null") Select option
      option(
        v-for="category in categories" 
        :value="category.id" 
        :key="category.id")
          | {{ category.name }}

  .md-form-group
    label {{ trans('pricebook.tags') }}
    multiselect(
      :loading="onLoading('fetch-tag')"
      name="tags"
      deselect-label=""
      label="name"
      select-label=""
      track-by="id"
      v-model="tags"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="tagList"
      @input="onFiltersChange"
      @search-change="refreshTagList"
    )
  
  .md-form-group
    label.md-check
      input(
        type="checkbox"
        v-model="addAll"
        @change="onToggleChange"
        )
      i.indigo 
      | Add All Matching
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TagMixin from '@js/mixins/tags';

export default {
    mixins: [TagMixin],
    props: {
        updateFilters: {
            type: Function,
            required: true,
        },
        onAddAllChange: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            addAll: false,
            category: null,
            tags: [],
            search: null,
        };
    },
    computed: {
        ...mapGetters('category', ['categories']),
    },
    created() {
        this.getTagListIfNecessary();
        this.getCategories();
    },
    methods: {
        onFiltersChange: _.debounce(function(query) {
            this.updateFilters({
                category: this.category,
                tags: this.tags,
                search: this.search,
            });
        }, 500),
        onToggleChange() {
            this.onAddAllChange(this.addAll);
        },
        ...mapActions('category', ['getCategories']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/template/filter-sidebar.vue